import Immutable from 'immutable';
import config from '../../config';
import store from "store2";

const LOAD = 'repots/LOAD';

const LOAD_REPORT_POWERBI_SUCCESS = 'repots/LOAD_REPORT_POWERBI_SUCCESS';
const LOAD_REPORT_CARE_SUCCESS = 'repots/LOAD_REPORT_CARE_SUCCESS';
const LOAD_REPORT_ADJUSTMENTS_SUCCESS = 'repots/LOAD_REPORT_ADJUSTMENTS_SUCCESS';
const LOAD_REPORT_WRITEOFFS_SUCCESS = 'repots/LOAD_REPORT_WRITEOFFS_SUCCESS';
const LOAD_DOCTOR_WORK_HISTORY_SUCCESS = 'repots/LOAD_DOCTOR_WORK_HISTORY_SUCCESS';
const LOAD_REPORT_SOC_SUCCESS = 'repots/LOAD_REPORT_SOC_SUCCESS';
const SEND_REPORT_SUCCESS = 'repots/SEND_REPORT_SUCCESS';

const LOAD_FAIL = 'repots/LOAD_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,

  reportCareDentists: null,
  reportCarePractice: null,

  reportAdjustmentsDentists: null,
  reportAdjustmentsPractice: null,

  reportWriteOffsDentists: null,
  reportWriteOffsPractice: null,
  reportWriteOffsCode: null,

  reportSocClinical: null,
  reportSocProcedures: null,
  rawReportSocClinical: null,
  rawReportSocProcedures: null,
  reportSocDefinition: null,

  reportPowerBI:null,

  isSendReport: false,
  doctorWorkHistory:[]
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_REPORT_POWERBI_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('reportPowerBI', action.reportPowerBI);
    case LOAD_DOCTOR_WORK_HISTORY_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('doctorWorkHistory', action.doctorWorkHistory);

    case LOAD_REPORT_CARE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('reportCareDentists', action.dentists)
        .set('reportCarePractice', action.practice);

    case LOAD_REPORT_ADJUSTMENTS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('reportAdjustmentDentists', action.dentists)
        .set('reportAdjustmentPractice', action.practice)
        .set('reportAdjustmentCode', action.adjustmentCode);

    case LOAD_REPORT_WRITEOFFS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('reportWriteOffsDentists', action.dentists)
        .set('reportWriteOffsPractice', action.practice)
        .set('reportWriteOffsCode', action.writeOffCode);

    case LOAD_REPORT_SOC_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('reportSocClinical', action.clinical)
        .set('rawReportSocClinical', action.rawClinical)
        .set('rawReportSocProcedures', action.rawProcedures)
        .set('reportSocProcedures', action.procedures)
        .set('reportSocDefinition', action.definition);

    case SEND_REPORT_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('isSendReport', action.data);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error);

    default:
      return state;
  }
};
export const  deleteReportPowerBI= (powerBI) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const id =parseInt(powerBI.id);
    powerBI.isDeleted=1;
    let reportPowerBI = getState().get('reports').get('reportPowerBI');
    await api.post('/reports/api/powerBI', { data: powerBI });
    reportPowerBI=reportPowerBI.filter(r=>r.id!==id);
    dispatch({
      type: LOAD_REPORT_POWERBI_SUCCESS,
      reportPowerBI
    });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
export const saveReportPowerBI = (powerBI) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const id=powerBI.id;
    let reportPowerBI = getState().get('reports').get('reportPowerBI');
    powerBI=await api.post('/reports/api/powerBI', { data: powerBI });
    if(!id) {
      reportPowerBI.push(powerBI);
      reportPowerBI = [...reportPowerBI]
    }else{
      reportPowerBI=reportPowerBI.map(r=>r.id===id?powerBI:r);
    }
    dispatch({
      type: LOAD_REPORT_POWERBI_SUCCESS,
       reportPowerBI
    });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
export const getReportPowerBI = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/powerBI`);
      dispatch({
        type: LOAD_REPORT_POWERBI_SUCCESS,
        reportPowerBI: res
      });
    } catch (err) {
       dispatch({ type: LOAD_FAIL, error: err.message });
    }
};
export const getDoctorWorkHistory = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/getDoctorWorkHistory/${JSON.stringify(id)}`);
      dispatch({
        type: LOAD_DOCTOR_WORK_HISTORY_SUCCESS,
        doctorWorkHistory: res
      });
      return res
    } catch (err) {
       dispatch({ type: LOAD_FAIL, error: err.message });
    }
};

export const getReportCareData = (params, tab) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    let res = await api.get(`reports/api/care/${params}`);
    const { result_1, result_2 } = res;

    if (tab === 1) {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: result_1,
        practice: getState().get('reports').get('reportCarePractice')
      });
    } else if (tab === 2) {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: getState().get('reports').get('reportCareDentists'),
        practice: result_2
      });
    } else {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: result_1,
        practice: result_2
      });
    }
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};


export const getScoreCardReportData = (month) => async (dispatch, getState, api) => {
  try {
    return await api.get(`reports/scoreCardData/${month}`);
  } catch (err) {
    return null
  }
};

export const getAllScoreCardReportData = () => async (dispatch, getState, api) => {
  try {
    return await api.get(`reports/getAllScoreCardData`);
  } catch (err) {
    return null
  }
};

export const saveScoreCardReportData = (data) => async (dispatch, getState, api) => {
  try{
    return await api.post(`reports/saveScoreCardData`, {data});
  } catch (err) {
    return null
  }
};

export const getReportCareDataScore = (params) => async (dispatch, getState, api) => {
  try {
    return await api.get(`reports/api/care/${params}`);
  } catch (err) {
    return  { result_1:[], result_2:[]}
  }
};

export const getSchedulesByDentists = (params) => async (dispatch, getState, api) => {
  try {
    const myHeaders = new Headers();
    const token = store('authToken');
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const response = await fetch(`${config.apiSchedule}/scheduler/getSchedulesByDentists/${params}`, requestOptions);

    if (!response.ok) {
      return [];
    }

    return  await response.json();

  } catch (err) {
    return [];
  }
};

export const getPCRSplashBoardReport = (date) => async (dispatch, getState, api) => {
  try {
    const myHeaders = new Headers();
    const token = store('authToken');
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const response = await fetch(`${config.apiMy}/report/allReportData/${date}/bySplashBoardReport`, requestOptions);

    if (!response.ok) {
      return [];
    }

    return await response.json();

  } catch (err) {
    return [];
  }
};

export const getOralSurgeryGoal = (params) => async (dispatch, getState, api) => {
  try {
    const myHeaders = new Headers();
    const token = store('authToken');
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    const response = await fetch(`${config.apiMy}/budget/${params}`, requestOptions);

    if (!response.ok) {
      return [];
    }

    return await response.json();

  } catch (err) {
    return [];
  }
};

export const getReportCareDeltaData = (params, tab) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    let res = await api.get(`reports/api/careDelta/${params}`);
    const { result_1, result_2 } = res;

    if (tab === 1) {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: result_1,
        practice: getState().get('reports').get('reportCarePractice')
      });
    } else if (tab === 2) {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: getState().get('reports').get('reportCareDentists'),
        practice: result_2
      });
    } else {
      dispatch({
        type: LOAD_REPORT_CARE_SUCCESS,
        dentists: result_1,
        practice: result_2
      });
    }
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getReportAdjustmentsData = (params, tab) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    let res = await api.get('reports/api/adjustments', { params });
    const { result_1, result_2, result_3 } = res;

    if (tab === 1) {
      dispatch({
        type: LOAD_REPORT_ADJUSTMENTS_SUCCESS,
        dentists: result_1,
        practice: getState().get('reports').get('reportAdjustmentPractice'),
        adjustmentCode: getState().get('reports').get('reportAdjustmentCode')
      });
    } else if (tab === 2) {
      dispatch({
        type: LOAD_REPORT_ADJUSTMENTS_SUCCESS,
        dentists: getState().get('reports').get('reportAdjustmentDentists'),
        practice: result_2,
        adjustmentCode: getState().get('reports').get('reportAdjustmentCode')
      });
    } else if (tab === 3) {
      dispatch({
        type: LOAD_REPORT_ADJUSTMENTS_SUCCESS,
        dentists: getState().get('reports').get('reportAdjustmentDentists'),
        practice: getState().get('reports').get('reportAdjustmentPractice'),
        adjustmentCode: result_3
      });
    } else {
      dispatch({
        type: LOAD_REPORT_ADJUSTMENTS_SUCCESS,
        dentists: result_1,
        practice: result_2,
        adjustmentCode: result_3
      });
    }
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getReportWriteOffScoreData = (params) => async (dispatch, getState, api) => {
    try {
      const res = await api.get('reports/api/writeoffs', { params });
    return res
  }
  catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getReportWriteoffsData = (params, tab) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('reports/api/writeoffs', { params });
    const { result_1, result_2, result_3 } = res;

    if (tab === 1) {
      dispatch({
        type: LOAD_REPORT_WRITEOFFS_SUCCESS,
        dentists: result_1,
        practice: getState().get('reports').get('reportWriteOffsPractice'),
        writeOffCode: getState().get('reports').get('reportWriteOffsCode')
      });
    } else if (tab === 2) {
      dispatch({
        type: LOAD_REPORT_WRITEOFFS_SUCCESS,
        dentists: getState().get('reports').get('reportWriteOffsDentists'),
        practice: result_2,
        writeOffCode: getState().get('reports').get('reportWriteOffsCode')
      });
    } else if (tab === 3) {
      dispatch({
        type: LOAD_REPORT_WRITEOFFS_SUCCESS,
        dentists: getState().get('reports').get('reportWriteOffsDentists'),
        practice: getState().get('reports').get('reportWriteOffsPractice'),
        writeOffCode: result_3
      });
    } else {
      dispatch({
        type: LOAD_REPORT_WRITEOFFS_SUCCESS,
        dentists: result_1,
        practice: result_2,
        writeOffCode: result_3
      });
    }
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getReportSOCData = (params, tab) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('reports/api/soc', { params });
    const { rawResult, result_1, result_2, result_3 } = res;

    if (tab === 1) {
      dispatch({
        type: LOAD_REPORT_SOC_SUCCESS,
        clinical: result_1,
        rawClinical: rawResult,
        procedures: getState().get('reports').get('reportSocProcedures'),
        definition: getState().get('reports').get('reportSocDefinition'),
        rawProcedures: getState().get('reports').get('rawReportSocProcedures')
      });
    } else if (tab === 2) {
      dispatch({
        type: LOAD_REPORT_SOC_SUCCESS,
        clinical: getState().get('reports').get('reportSocClinical'),
        rawClinical: getState().get('reports').get('rawReportSocClinical'),
        procedures: result_2,
        rawProcedures: rawResult,
        definition: getState().get('reports').get('reportSocDefinition')
      });
    }  else if (tab === 3) {
      dispatch({
        type: LOAD_REPORT_SOC_SUCCESS,
        definition: result_3
      });
    }  else {
      dispatch({
        type: LOAD_REPORT_SOC_SUCCESS,
        clinical: result_1,
        procedures: result_2,
        rawClinical: rawResult,
        definition: result_3,
        rawProcedures: rawResult
      });
    }
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getSendReportData = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('reports/api/sendReport', { params });
    const { data } = res;
      dispatch({
        type: SEND_REPORT_SUCCESS,
        data
      });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
